// extracted by mini-css-extract-plugin
export default {"card":"_card_card__4bMF7","card__oval":"_card_card__oval__MziQX","card__img":"_card_card__img__eW8zK","card__description":"_card_card__description__1mEnX"};